import { render, staticRenderFns } from "./dyGoods.vue?vue&type=template&id=0b7609dc&scoped=true&"
import script from "./dyGoods.vue?vue&type=script&lang=js&"
export * from "./dyGoods.vue?vue&type=script&lang=js&"
import style0 from "./dyGoods.vue?vue&type=style&index=0&id=0b7609dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7609dc",
  null
  
)

export default component.exports